import { UNDER_CONSTRUCT_CAPTION } from '@modules/analytics/common/constants';
import { Result } from 'antd';

const ILSAnalyticsTenderReportsComponent = () => {
  return <Result className="analytics-under-construct" status={'info'} title={<p>{UNDER_CONSTRUCT_CAPTION}</p>} />;
};

export default ILSAnalyticsTenderReportsComponent;
